import { onStateChange } from "./helpers/utils"

export function sliderHandler() {
  let sliders = document.querySelectorAll(".glide")
  if (sliders.length > 0) {
    sliders.forEach((x) => {
      var autoplay = x.getAttribute("id") ? x.getAttribute("id") : false
      new window.Glide(x, {
        autoplay: autoplay,
        startAt: 0,
        perView: 1,
        gap: 0,
        keyboard: false,
        dragThreshold: false,
      }).mount()
    })
  }

  var lazyImages = [].slice.call(
    document.querySelectorAll(".glide .glide__slide img[data-src]")
  )

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute(
            "src",
            entry.target.getAttribute("data-src")
          )
          lazyImageObserver.unobserve(entry.target)
        }
      })
    })

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage)
    })
  } else {
    for (var i = 0; i < lazyImages.length; i++) {
      lazyImages[i].setAttribute(
        "src",
        lazyImages[i].getAttribute("data-war-media-src")
      )
    }
  }
}

export default () => onStateChange(sliderHandler)
